import {MI} from "../init.js";

import {FsInfo} from "./FsInfo";
import {LinesInfo} from "./LinesInfo";

/**
 * @constructor
 * @param {Game} game
 * @returns {GameHeader}
 */
export function GameHeader(game) {

    this._game = game;

    /** @type {MadnesObject} */
    this._logo;

    /** @type {boolean} */
    this._logoShowed = true;

    /** @type {FsInfo} */
    this._fsInfo = new FsInfo(this._game);
    this._linesInfo = new LinesInfo();

    /** @type {MadnesTween} */
    this._tweenLogoShow;
    /** @type {MadnesTween} */
    this._tweenLogoHide;
};

GameHeader.prototype.create = function() {

    this._logo = MI.addImg(MI.getWi() / 2 + 4, -2, "reels_atlas").setFrameName("logo").setAnchor(0.5, 0);
//	var l = MI.addImg(0, -10, "logo_atlas").setFrameName("logo").setAnchor(0.5, 0);
//	this._logo.addChild(l);


    this._fsInfo.create();
    this._fsInfo.hide();

    this._linesInfo.create();
    this._linesInfo.hide();
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
GameHeader.prototype._hideLogo = function(duration) {
//	var _self = this;

    if(typeof duration === 'undefined') { duration = 200; };

    return new Promise(function(res) {

//		_self._tweenLogoShow && _self._tweenLogoShow.stop();
//
//		if(!_self._logoShowed /*|| _self._logo.getPosY() <= -110*/) {
        res();
//			return;
//		}
//
//		_self._tweenLogoHide = MI.addTween().to(_self._logo, { 'y': -110 }, {
//			'duration': duration,
//			'callback': function() {
//				_self._logo.setPosY(-110)
//				_self._logo.kill();
//				_self._logoShowed = false;
//				res();
//			}
//		});
    });
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
GameHeader.prototype._showLogo = function(duration) {
//	var _self = this;

    if(typeof duration === 'undefined') { duration = 200; };

    return new Promise(function(res) {
//
//		_self._tweenLogoHide && _self._tweenLogoHide.stop();
//
//		_self._logo.revive();
//
//		if(_self._logoShowed) {
        res();
//			return;
//		}
//
//		_self._tweenLogoShow = MI.addTween().to(_self._logo, { 'y': 0 }, {
//			'duration': duration,
//			//'easing': MadnesTween.getEasing("back_out"),
//			'callback': function() {
//				_self._logo.setPosY(0);
//				_self._logoShowed = true;
//				res();
//			}
//		});
    });
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
GameHeader.prototype.showFS = function(duration) {
    var _self = this;

    return Promise.all([this._hideLogo(duration), this._linesInfo.hide(duration)]).then(function() {
        return _self._fsInfo.show(duration);
    });
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
GameHeader.prototype.showLogo = function(duration) {
    var _self = this;

    return Promise.all([this._linesInfo.hide(duration), this._fsInfo.hide(duration)]).then(function() {
        return _self._showLogo();
    });
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
GameHeader.prototype.showLines = function(duration) {
    var _self = this;

    return Promise.all([this._hideLogo(duration), this._fsInfo.hide(duration)]).then(function() {
        return _self._linesInfo.show(duration);
    });
};

/**
 * @param {number} num
 */
GameHeader.prototype.drawLine = function(num) {
    this._linesInfo.drawLine(num);
};

/**
 * @param {number} count
 * @param {number} all
 */
GameHeader.prototype.setFS = function(count, all) {
    this._fsInfo.set(count, all);
};

/**
 * @param {number} from
 * @param {number} to
 * @param {number} actual
 * @returns {Promise}
 */
GameHeader.prototype.countFS = function(from, to, actual) {
    return this._fsInfo.count(from, to, actual);
};